<template>
  <section>
      <div id="detailsBox">
          <div class="topBar">
            <p class="detailsTitle">{{folder.title}}</p>
            <div class="back" @click="toggleDetails"></div>
          </div>
         <div class="documentBox">
            <div class="documentRow">
              <AddDocument />
            </div>
          </div>
      </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import AddDocument from '@/components/upload/AddDocument';

export default {
    props: ["folder"],

    components: {
      AddDocument,
    },

    computed: {
        ...mapState("upload", ["isAddingFolder", "game"]),
        ...mapState("upload", ["isShowingDetails"]),
    },
    methods: {
      toggleDetails(){
        this.folder.showDetails = false;
      }
    }

}
</script>

<style  scoped>
#detailsBox {
  display: flex;
  flex-direction: column;
  background-color: white;
  top: 82px !important;
  bottom: 5px;
  right: 5px !important;
  left: 25%;
  position: fixed !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  border: #f0f0f0 solid;
  border-width: 5px 5px 5px 5px;
  border-radius: 13px !important;
}

.detailsTitle{
  flex-basis: 20%;
  text-align: center;
  font-size: 35px;
  color: black;
  margin: 5px;
}

.back{
    margin-left: 70%;
    margin-top: 5px;
    display:inline-block;
    cursor: pointer;
    width:50px;
    height:50px;
    background:linear-gradient(#000,#000), linear-gradient(#000,#000);
    background-position:center;
    background-size: 50% 2px,2px 50%; /*thickness = 2px, length = 50% (25px)*/
    background-repeat:no-repeat;
    transform: rotate(45deg);
}

</style>